import { FormSection } from "Components/Shared/FormSection";
import { useGenderList } from "Hooks/Options/useGenderList";
import { formatDate } from "Utils/DateUtils";
import { useCountryNameResolver } from "Translations/countryNames";
import { Resources, useResource } from "Translations/Resources";
import type { PartyDto } from "Infrastructure/Api/Api";
import { Stack } from "@mui/material";
import { DataRow } from "Components/Shared/DataRow/DataRow";

const COMPONENT_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.Party.Form.NaturalPerson;

type Props = {
  party: PartyDto;
};

export const PersonalDataDisplay = ({
  party: {
    gender,
    nationality: nationalityCode,
    otherNationalities,
    birthDate,
    firstName,
    lastName,
    personalNumber,
    birthPlace,
  },
}: Props) => {
  const { t } = useResource();
  const genders = useGenderList();
  const { getCountryName, getCountryNames } = useCountryNameResolver();

  const formattedBirthDate = formatDate(birthDate);
  const translatedGender = genders.find(({ code }) => code === gender)?.name;
  const nationality = getCountryName(nationalityCode);

  return (
    <FormSection legend={t(COMPONENT_RESOURCES.Legend.PersonalData)}>
      <Stack gap={2}>
        <DataRow label={t(COMPONENT_RESOURCES.FirstName)} value={firstName} />
        <DataRow label={t(COMPONENT_RESOURCES.LastName)} value={lastName} />
        <DataRow
          label={t(COMPONENT_RESOURCES.PersonalNumber)}
          value={personalNumber}
        />
        <DataRow
          label={t(COMPONENT_RESOURCES.BirthDate)}
          value={formattedBirthDate}
        />
        <DataRow
          label={t(COMPONENT_RESOURCES.Gender)}
          value={translatedGender}
        />
        <DataRow label={t(COMPONENT_RESOURCES.BirthPlace)} value={birthPlace} />
        <DataRow label={t(Resources.Common.Nationality)} value={nationality} />
        {otherNationalities.length > 0 && (
          <DataRow
            label={t(Resources.Common.OtherNationalities)}
            value={getCountryNames(otherNationalities)}
          />
        )}
      </Stack>
    </FormSection>
  );
};
